var selectors = {};
export {
  selectors as __exports
};
//# sourceMappingURL=index5.js.map
